import React from 'react';
import { useThemeMode } from '../ThemeContext';
import AppIconBlue from '../assets/AppIconBlue.svg';
import '../styles/loading-animations.css';

const LoadingProgressBar = ({ isVisible, message = "Loading..." }) => {
  const { mode } = useThemeMode();

  if (!isVisible) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: '85px', // Below the topbar (matches header min-height)
        left: '235px', // Right of the sidebar (matches actual sidebar width)
        right: '0px',
        bottom: '0px',
        zIndex: 1099,
        backgroundColor: mode === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(4px)',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 0,
        paddingBottom: 0
      }}
    >
      {/* Fill Animation Loading Indicator */}
      <div className="fill-animation-container">
        {/* Background container */}
        <div className="fill-animation-background" />
        
        {/* Progress fill animation */}
        <div className="fill-animation-progress" />
        
        {/* AppIconBlue with pulse animation */}
        <img 
          src={AppIconBlue} 
          alt="Loading" 
          className={`fill-animation-icon pulse-animation-icon`}
        />
      </div>


    </div>
  );
};

export default LoadingProgressBar;
